import {
  DistanceFilterDropdown,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/DistanceFilterDropdown'

export function MetersToSkiLiftFilter() {
  return (
    <DistanceFilterDropdown
      filterType="MetersToSkiLift"
      labelId="search_filter_meters_to_ski_lift_label"
      analyticsType="distance from ski lift"
      dataQa="meters-to-ski-lift-filter"
    />
  )
}
